export default "__VITE_ASSET__5PfrTfAZ__";